import SalesAndBalance from "./SalesAndBalance";
const salesAndBalance={
     SalesAndBalance
}
export default salesAndBalance
